import React from 'react'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import { useField } from 'formik'
import FormHelperText from '@material-ui/core/FormHelperText'
import { Typography, InputLabel } from '@material-ui/core'

type DropdownProps = {
    disabled?: boolean
    label?: string
    name: string
    placeholder?: string
    style?: {}
    value?: any
    items?: Array<any>
    inputLabel?: string
    handleChange?: (e) => void
}

const ValidatedDropdown = (props: DropdownProps) => {
    const { items, inputLabel, label, name, placeholder, value, handleChange, disabled } = props
    const [field, meta] = useField(name)

    const error = !!(meta.error && meta.touched)
    const helperText = error ? meta.error : null
    const disabledDefault = disabled === undefined ? false : disabled
    return (
        <>
            <FormControl variant="outlined" fullWidth={true} error={error}>
                {inputLabel && (<InputLabel>{inputLabel}</InputLabel>)}
                <Select
                    name={name}
                    value={value}
                    displayEmpty
                    onChange={handleChange ? handleChange : field.onChange}
                    label={label}
                    disabled={disabledDefault}
                >
                    {placeholder && (
                        <MenuItem value="">
                            <Typography variant="body1">{placeholder}</Typography>
                        </MenuItem>
                    )}

                    {items?.map((item, index) => {
                        return (
                            <MenuItem key={index} value={item.value || item}>
                                <Typography variant="body1">{item.label || item}</Typography>
                            </MenuItem>
                        )
                    })}
                </Select>
            </FormControl>
            <FormHelperText style={{ color: 'red' }}>{helperText}</FormHelperText>
        </>
    )
}

export default ValidatedDropdown
